import React from "react";
import { Navigate } from "react-router-dom";

// Notas de débito se movieron a /sri/debit-notes — estas rutas se dejan
// como redirect para no romper enlaces/bookmarks viejos a /finanzas/debit-note/*.
export const debitNoteRoutes = [
  {
    path: "add",
    element: <Navigate replace to="/sri/debit-notes/add" />,
  },
  {
    path: "list",
    element: <Navigate replace to="/sri/debit-notes/issued" />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/debit-notes/issued" />,
  },
];
